export default __webpack_public_path__ + "static/media/walking.24e763c1.jpeg";